import { getNumericOperators } from '../../utils/getNumericOperators';
import { getDateOperators } from '../../utils/getDateOperators';
import { CustomCell } from './components/custom-cell';
import { SelectCell } from './components/select-cell';
import { thousandSeparator } from '../reqs-filter/utils';
import { getStringOperators } from '../../utils/getStringOperators';

export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';

export const TABLE_PLANNINGS_PROCESS_COLUMNS = configs => [
	{
		headerName: '#',
		field: 'id',
		width: 50,
		minWidth: 50,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Конфигурация',
		field: 'config_id',
		flex: 1,
		width: 50,
		type: 'singleSelect',
		valueOptions: configs,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.config) {
				return '';
			}

			return row.config.id;
		},
	},
	{
		headerName: 'Статус',
		field: 'status_id',
		width: 220,
		sortable: false,
		filterable: false,
		valueGetter: (value, row) => {
			if (!row.status) {
				return '';
			}

			return row.status.name;
		},
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Кол-во точек',
		field: 'count_orders',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		sortable: false,
		filterable: false,
		valueGetter: (value, row) => {
			if (!row.count_orders || row.count_orders_planned === null) {
				return '---';
			}

			return `${row.count_orders_planned ?? 0}/${row.count_orders ?? 0}`;
		},
	},
	{
		headerName: 'Кол-во маршрутов',
		field: 'count_ways',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
		valueGetter: (value, row) => {
			if (row.count_ways === null) {
				return '---';
			}

			return row.count_ways;
		},
	},
	{
		headerName: 'Расходы',
		field: 'cost',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
		valueGetter: (value, row) => {
			if (!row.cost) {
				return '---';
			}

			return `${thousandSeparator(row.cost)} руб`;
		},
	},
	{
		headerName: 'Пробег',
		field: 'distance',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
		valueGetter: (value, row) => {
			if (!row.distance) {
				return '---';
			}

			return `${thousandSeparator(row.distance, 3)} км`;
		},
	},
	{
		headerName: 'Дата',
		field: 'created_at',
		flex: 1,
		type: 'date',
		filterOperators: getDateOperators(),
		formatter: value => new Date(value).toLocaleDateString('ru-RU'),
		valueGetter: (value, row) => {
			if (!row.created_at) {
				return value;
			}

			return new Date(row.created_at);
		},
	},
	{
		headerName: 'Ссылка',
		field: 'link',
		width: 100,
		sortable: false,
		filterable: false,
		headerAlign: 'center',
		align: 'center',
		renderCell: params => CustomCell(params),
	},
	{
		headerName: '',
		field: 'actions',
		width: 150,
		headerAlign: 'center',
		align: 'center',
		sortable: false,
		filterable: false,
		// eslint-disable-next-line react/react-in-jsx-scope
		renderCell: params => <SelectCell rowData={params.row} />,
	},
];

export const TABLE_COLLECTION_COLUMNS = modes => [
	{
		headerName: ' ',
		field: 'empty',
		width: 100,
		sortable: false,
		filterable: false,
		disableColumnMenu: true,
		disableExport: true,
	},
	{
		headerName: 'Адрес отгрузки',
		field: 'address_from',
		flex: 1,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (!value) {
				return value;
			}

			return value.address;
		},
	},
	{
		headerName: 'Адрес доставки',
		field: 'address_to',
		minWidth: 100,
		flex: 1,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (!value) {
				return value;
			}

			return value.address;
		},
	},
	{
		headerName: 'Дата доставки',
		field: 'date_to',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getDateOperators(),
		valueGetter: value => {
			if (!value) {
				return value;
			}

			return new Date(value).toLocaleDateString('ru-RU');
		},
	},
	{
		headerName: 'Т-режим',
		field: 'mode_id',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		sortable: false,
		type: 'singleSelect',
		valueOptions: modes,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.mode) {
				return '';
			}

			return row.mode.id;
		},
	},
	{
		headerName: 'Кол. заказов',
		field: 'orders_count',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(['isAnyOf']),
	},
	{
		headerName: 'Масса, кг',
		field: 'weight',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(['isAnyOf']),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
	{
		headerName: 'Объем, м³',
		field: 'volume',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(['isAnyOf']),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
	{
		headerName: 'Места, шт',
		field: 'place',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(['isAnyOf']),
	},
	{
		headerName: 'Стоимость груза',
		field: 'cost',
		flex: 1,
		filterOperators: getNumericOperators(['isAnyOf']),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
